jQuery( document ).ready(function($) {


  if($('.promosbanners').length > 0) {

    $('.promosbanners_carousel').owlCarousel({
      loop: true,
      nav: false,
      dots: false,
      autoplay: true,
      autoplayTimeout: 4000,
      items: 1
  })}

});

